// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"7a2563ee","338":"a7e6ea30","510":"68f51a30","524":"bf489902","672":"cc344bf3","957":"a8d16bd0"}[chunkId] + ".chunk.css";
};